import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'g10-master-layout',
  templateUrl: './master-layout.component.html',
  styleUrls: ['./master-layout.component.css']
})
export class MasterLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
